import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dialog'];

  open(event) {
    event.preventDefault();
    this.dialogTarget.showModal();
  }

  cancel() {
    this.dialogTarget.close();
  }
}
